let lastY = 0;
let headerEl = null;

const initialize = (el) => {
  lastY = window.scrollY;
  headerEl = el;
  window.addEventListener("scroll", onScroll);

  const menuButton = el.querySelector("#gd-header-menu-button");
  menuButton.addEventListener("click", () => {
    const drawer = el.querySelector(".gd-mobile-menu-drawer");
    drawer.classList.add("open");
  });

  const menuCloseButton = el.querySelector("#gd-header-menu-close");
  menuCloseButton.addEventListener("click", () => {
    const drawer = el.querySelector(".gd-mobile-menu-drawer");
    drawer.classList.remove("open");
  });
};

const onScroll = () => {
  if (window.scrollY < lastY) {
    headerEl.classList.add("show");
  } else {
    headerEl.classList.remove("show");
  }
  lastY = window.scrollY;
};

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector("header.gd-header");
  if (el) {
    initialize(el);
  }
});
